import React from "react";
import banner from "../assets/products.jpg";
import { Card } from "primereact/card";
import { Link } from "react-router-dom";
export default function Products() {
  return (

    <div>
      <div
        style={{
          width: "100%",
          height: "300px",
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff"
        }}
      >
        <h1>Products</h1>
      </div>
      <div className="p-5">
        <div className="center-text-section">
          <h2>Custom Widgets for IBM Engineering Lifecycle Management</h2>
          <p>
            Please click on the card to get more details about the Widgets.
          </p>
        </div>
        
       <div className="grid mt-5">
          {/*     <div className="col-12 md:col-4">
            <div className="hover-card">
              <Link to="/copy-view-widget" className="card-link">
                <Card title="Copy View Widget">
                </Card>
              </Link>
            </div>
          </div>      */}

          <div className="col-12 md:col-4">
            <div className="hover-card">

              <Link to="/comments-filter" className="card-link">
                <Card title="Filter Comments Widget" />
              </Link>
            </div>
          </div>

          <div className="col-12 md:col-4">
            <div className="hover-card">
              <Link to="/glossary-widget" className="card-link">
                <Card title="Glossary Widget" />
              </Link>
            </div>
          </div>

          <div className="col-12 md:col-4">
            <div className="hover-card">
              <Link to="/file-gallery-widget" className="card-link">
                <Card title="File Gallery Widget" />
              </Link>
            </div>
          </div>

          <div className="col-12 md:col-4">
            <div className="hover-card">
              <Link to="/review-comments-widget" className="card-link">
                <Card title="Review Comments Widget" />
              </Link>
            </div>
          </div>


          {/* <div className="col-12 md:col-4">
          <div className="hover-card">
            <Card title="Consulting">
              <p>Expert guidance for enterprise solutions.</p>
            </Card>
          </div>
        </div> */}
        </div>
        <div className="center-text-section">
          <p>
            Please write to <a href="mailto:hr@pesilinfosol.com">hr@pesilinfosol.com</a> from your company email to request for a Demo, after which we can provide a 30-day trial version that can be deployed to your environment.
          </p>
          <p>
            PESIL can also develop custom widgets for your needs.
          </p>
        </div>

      </div>
    </div>
  )
}
